'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _Pagination = require('react-bootstrap/lib/Pagination');

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var onPageClick = function onPageClick(page, onSelect) {
    return function (e) {
        e.stopPropagation();
        onSelect(page);
    };
};

var createPageButton = function createPageButton(page, activePage, onSelect) {
    return _react2.default.createElement(
        _Pagination2.default.Item,
        {
            key: page,
            onClick: onPageClick(page, onSelect),
            active: page === activePage },
        page
    );
};
var RecreatePagination = function RecreatePagination(_ref) {
    var maxButtons = _ref.maxButtons,
        boundaryLinks = _ref.boundaryLinks,
        items = _ref.items,
        first = _ref.first,
        last = _ref.last,
        activePage = _ref.activePage,
        onSelect = _ref.onSelect,
        rest = _objectWithoutProperties(_ref, ['maxButtons', 'boundaryLinks', 'items', 'first', 'last', 'activePage', 'onSelect']);

    var pageButtons = [];

    var startPage = void 0;
    var endPage = void 0;
    var hasHiddenPagesAfter = void 0;

    if (maxButtons) {
        var hiddenPagesBefore = activePage - parseInt(maxButtons / 2, 10);
        startPage = hiddenPagesBefore > 1 ? hiddenPagesBefore : 1;
        hasHiddenPagesAfter = startPage + maxButtons <= items;

        if (!hasHiddenPagesAfter) {
            endPage = items;
            startPage = items - maxButtons + 1;
            if (startPage < 1) {
                startPage = 1;
            }
        } else {
            endPage = startPage + maxButtons - 1;
        }
    } else {
        startPage = 1;
        endPage = items;
    }
    for (var page = startPage; page <= endPage; page++) {
        pageButtons.push(createPageButton(page, activePage, onSelect));
    }
    if (startPage !== 1) {
        if (!boundaryLinks || startPage !== 2) {
            pageButtons.unshift(_react2.default.createElement(_Pagination2.default.Ellipsis, { key: 'hidden-before', disabled: true }));
        }
        if (boundaryLinks) {
            pageButtons.unshift(createPageButton(1, activePage, onSelect));
        }
    }
    if (hasHiddenPagesAfter) {
        if (!boundaryLinks || endPage !== items - 1) {
            pageButtons.push(_react2.default.createElement(_Pagination2.default.Ellipsis, { key: 'hidden-after', disabled: true }));
        }
        {
            boundaryLinks && endPage !== items && pageButtons.push(createPageButton(items, activePage, onSelect));
        }
    }
    return _react2.default.createElement(
        _Pagination2.default,
        rest,
        _react2.default.createElement(
            _Pagination2.default.First,
            {
                disabled: activePage === 1,
                onClick: onPageClick(1, onSelect) },
            first
        ),
        (0, _map2.default)(pageButtons, function (btn) {
            return btn;
        }),
        _react2.default.createElement(
            _Pagination2.default.Last,
            {
                disabled: activePage === items,
                onClick: onPageClick(items, onSelect) },
            last
        )
    );
};
RecreatePagination.propTypes = {
    className: _propTypes2.default.string,
    bsSize: _propTypes2.default.string,
    maxButtons: _propTypes2.default.number.isRequired,
    boundaryLinks: _propTypes2.default.bool,
    items: _propTypes2.default.number.isRequired,
    activePage: _propTypes2.default.number.isRequired,
    onSelect: _propTypes2.default.func.isRequired,
    first: _propTypes2.default.node.isRequired,
    last: _propTypes2.default.node.isRequired
};
exports.default = RecreatePagination;
//# sourceMappingURL=index.js.map